import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const CTABanner = () => (
  <Box sx={{
    bgcolor: '#020817', py: { xs: 8, md: 10 }, position: 'relative', overflow: 'hidden',
  }}>
    <Box sx={{ position: 'absolute', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(8,145,178,0.15) 0%, transparent 60%)', bottom: -200, right: -200, pointerEvents: 'none' }} />
    <Box sx={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 60%)', top: -100, left: -100, pointerEvents: 'none' }} />

    <Container maxWidth="md" sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
      <Typography sx={{ color: '#22d3ee', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 2, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>
        Start Closing More Deals
      </Typography>
      <Typography variant="h2" sx={{ color: '#fff', fontWeight: 900, mb: 3, fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '2rem', md: '3.2rem' }, lineHeight: 1.15 }}>
        300+ Builders Trust Us.{' '}
        <Box component="span" sx={{ background: 'linear-gradient(90deg,#22d3ee,#818cf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          You Should Too.
        </Box>
      </Typography>
      <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 17, mb: 5, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>
        Get a personalized demo and see exactly how our Real Estate CRM will impact your business. Free setup, free training, free integration with your existing portals.
      </Typography>
      <Grid container spacing={2} justifyContent="center">
        <Grid item><Button variant="contained" endIcon={<ArrowForwardIcon />} size="large" sx={{ bgcolor: '#0891b2', px: 5, py: 1.7, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: 16, boxShadow: '0 8px 32px rgba(8,145,178,0.5)', '&:hover': { bgcolor: '#0e7490' } }}>Book Free Demo</Button></Grid>
        <Grid item><Button variant="outlined" startIcon={<PhoneIcon />} size="large" sx={{ borderColor: 'rgba(255,255,255,0.3)', color: '#fff', px: 5, py: 1.7, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 700, '&:hover': { borderColor: '#22d3ee', bgcolor: 'rgba(34,211,238,0.05)' } }}>+91 97408 57368</Button></Grid>
      </Grid>
    </Container>
  </Box>
);

export default CTABanner;
